import { usePathname } from '@mentimeter/next-navigation';
import { revalidatePathAction } from './revalidate-path-action';

export function usePathRevalidator() {
  const pathname = usePathname();

  return async () => {
    await revalidatePathAction(pathname);
  };
}
